import { SpeedInsights } from "@vercel/speed-insights/react"
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ConstitutionViewer from "./components/ConstitutionViewer";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ScrollTop from "./components/ScrollTop";
import AlumniStudentsForm from "./forms/AlumniStudentsForm";
import About from "./pages/About";
import AchievementsSection from "./pages/Achievements/AchievementSection";
import CulturalDisplay from "./pages/Achievements/Cultural-Display";
import IndependentCelebration from "./pages/Achievements/Independence";
import InterStateChampionship from "./pages/Achievements/Inter-StateChampionship";
import StudentWeeks from "./pages/Achievements/StudentWeeks";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import Home from "./pages/Home";
import IndAchivementsDetailPage from "./pages/IndAchivementsPage";
import Members from "./pages/Members";
import StudentRegistration from "./pages/Registration";
import Resources from "./pages/Resources";
import StudentProfile from "./pages/StudentProfile";

function App() {
  return (
    <Router>
      <SpeedInsights />
      <div className="flex flex-col min-h-screen">
        <header className="fixed top-0 left-0 w-full z-50">
          <ScrollTop />
          <Header />
        </header>
        <main className="flex-grow pt-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/forms" element={<AlumniStudentsForm />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/members" element={<Members />} />
            <Route path="/constitution" element={<ConstitutionViewer />} />
            <Route path="/profile/:id" element={<StudentProfile />} />
            <Route path="/registration" element={<StudentRegistration />} />
            <Route
              path="/achievements/:id"
              element={<IndAchivementsDetailPage />}
            />
            <Route
              path="/achievementection"
              element={<AchievementsSection />}
            />
            <Route path="/achievement" element={<AchievementsSection />} />
            <Route
              path="/achievement/independent-celebration"
              element={<IndependentCelebration />}
            />
            <Route
              path="/achievement/student-weeks"
              element={<StudentWeeks />}
            />
            <Route
              path="/achievement/inter-state-championship"
              element={<InterStateChampionship />}
            />
            <Route
              path="/achievement/cultural-display"
              element={<CulturalDisplay />}
            />
            

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
